import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEye, FiEdit, FiTrash2, FiPlus, FiMinus, AiOutlineClose } from 'react-icons/fi'; // Using react-icons library
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for toast notifications
import { FiChevronDown, FiChevronUp, } from 'react-icons/fi';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { AiOutlineClose as CloseIcon } from 'react-icons/ai';
import { GetAllCouriers, AddCourierMaster, UpdateCourierMaster } from '../../services/Api';


// Your existing code...


const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
      color:#2B3497;

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000;
`;
// const Input = styled.input`
//   width: 100%;
//   padding: 8px 0;
//   border: none;
//   border-bottom: 1px solid #2B3497;
//   font-family: 'Segoe UI', 'Regular';
//   margin-top:10px;
//   background: transparent;
//   &:focus {
//     outline: none;
//     border-bottom: 2px solid #2B3497;
//   }
// `;


const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;

  &.add-location {
    background-color: #293495;
  }

  &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }
`;

const LocationInput = styled.input`
  border: none;
  border-bottom: 2px solid #3d46b4;
  outline: none;
  font-size: 16px;
  padding: 10px;
  margin-left: 20px;
  width: 200px;
  background: transparent;
`;

const TableContainer = styled.div`
  margin-top: 20px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
      cursor: pointer;

`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;
const Asterisk = styled.span`
  color: red;
`;

// const DropdownSelect = styled.select`
//   background-color: #fff;
//   color: #293495;
//   boder:none;
//   border-bottom: 1px solid #3d46b4;
//   padding: 8px;
//   border-radius: 5px;
//   cursor: pointer;
//   font-size: 16px;
//   &:focus {
//     outline: none;
//     border-color: #293495;
//   }
// `;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: linear-gradient(#FFFFFF, #F5F5F5, #FFFFFF);
  box-shadow: 0px 0px 1px #0000004A;
  border-radius: 30px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;
const LabelValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;
export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 29px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  z-index: 1000;
  width: 80%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom:10px;
`;

export const ModalTitle = styled.h2`
  color: #293495;
  font-size: 20px;
  margin: 0;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FlexRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

export const InputFieldHalf = styled.div`
  flex: 1;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #000;
  font-weight: 600;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#2B3497')};
  font-family: 'Segoe UI', 'Regular';
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#2B3497')};
  }
`;

const DropdownSelect = styled.select`
  border: none;
  border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#293495')};
  padding: 8px 0;
  font-size: 14px;
  outline: none;
  background: transparent;
  background-image: url('data:image/svg+xml;utf8,<svg fill="none" stroke="${props =>
        props.hasError ? 'red' : '%23293495'}" stroke-width="2" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7"/></svg>');
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px 16px;
  cursor: pointer;

  &:focus {
    border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#1a237e')};
  }
`;

export const ResetButton = styled.button`
   background-color: red;
margin-top: 20px;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  float: right;
  cursor: pointer;

  &:hover {
    background-color: darkred;
  }
`;

export const SubmitButton = styled.button`
 margin-top: 20px;
  background-color: #293495;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  float: right;
  cursor: pointer;

  &:hover {
    background-color: #1f2970;
  }
`;
const TextArea = styled.textarea`
   width: 100%;
  padding: 0px 0;
  border: none;
  border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#2B3497')};
  font-family: 'Segoe UI', 'Regular';
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid ${props => (props.hasError ? 'red' : '#2B3497')};
  }
`;



const CourierMaster = () => {
    const [showInput, setShowInput] = useState(false);
    const [locationName, setLocationName] = useState('');
    const [locations, setLocations] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [showPagination, setShowPagination] = useState(false);
    const [sortColumn, setSortColumn] = useState('');
    const [sortDirection, setSortDirection] = useState('asc');
    const [allCouriers, setAllCouriers] = useState([]);

    // Sort function

    const rowsPerPage = 5;

    const fetchAllCourier = async () => {
        try {
            const response = await GetAllCouriers();
            console.log("all Courier", response);
            setAllCouriers(response);
        } catch (error) {
            console.error('Error All Couriers:', error);
        }
    }
    console.log("All Couriers", allCouriers);


    useEffect(() => {

        fetchAllCourier();
    }, []);

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const response = await axios.get('/Location');
                if (response.data) {
                    // Assuming the API returns an array of locations
                    setLocations(response.data);
                    setShowPagination(true); // Show pagination after submitting at least one row

                } else {
                    setLocations([]); // Ensure locations is always an array
                }
            } catch (error) {
                console.error('Error fetching locations:', error);
                setLocations([]); // Ensure locations is always an array even if the request fails
            }
        };

        fetchLocations();
    }, []);
    const sortData = (data, column, direction) => {
        const sortedData = [...data].sort((a, b) => {
            if (direction === 'asc') {
                return a[column] > b[column] ? 1 : -1;
            } else {
                return a[column] < b[column] ? 1 : -1;
            }
        });
        return sortedData;
    };

    const handleSort = (column) => {
        const newDirection = sortColumn === column && sortDirection === "asc" ? "desc" : "asc";
        setSortColumn(column);
        setSortDirection(newDirection);

        console.log("Couriers", allCouriers);

        const sortedData = [...allCouriers].sort((a, b) => {
            let valA = a[column];
            let valB = b[column];

            if (column.includes("DateTime")) {
                valA = new Date(valA);
                valB = new Date(valB);
            }

            if (valA < valB) return newDirection === "asc" ? -1 : 1;
            if (valA > valB) return newDirection === "asc" ? 1 : -1;
            return 0;
        });

        setAllCouriers(sortedData);
    };


    const handleAddLocationClick = () => {
        handleReset();
        setIsModalOpen(true)
    };
    const handleCloseModal = () => {
        setIsEditing(false);
        setIsModalOpen(false);
        setErrors({});
    }

    // const handleEdit = (location) => {
    //     console.log("location Data", location);
    // }


    const handleDelete = (id) => {
        confirmAlert({
            title: <span style={{ color: '#dc3545' }}>Warning</span>,
            message: 'Are you sure you want to delete this location?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: async () => {
                        try {
                            // Sending the PUT request to mark the location as deleted
                            await axios.put('/Location', {
                                id: id,
                                locationName: locations.find(location => location.id === id)?.locationName,
                                isDeleted: true
                            });

                            // Update the local state to remove the deleted location from the UI
                            setLocations((prevData) => prevData.filter(location => location.id !== id));

                            // Show success toast message
                            toast.success('Location Deleted Successfully');
                        } catch (error) {
                            console.error('Error deleting location:', error);
                            // Show error toast message
                            toast.error('Failed to Delete Location');
                        }
                    }
                },
                {
                    label: 'No',
                    onClick: () => {
                        // Close dialog without taking any action
                    }
                }
            ]
        });
    };


    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Filtered keys
    const filteredKeys = Array.isArray(allCouriers)
        ? allCouriers.filter(item => {
            const term = searchTerm?.toLowerCase().trim();
            if (!term) return true;

            const excludeKeys = ['createdBy', 'createdOn', 'modifiedBy', 'modifiedOn'];

            return Object.entries(item).some(([key, value]) =>
                !excludeKeys.includes(key) &&
                String(value ?? '').toLowerCase().includes(term)
            );
        })
        : [];


    // Pagination logic
    const itemsPerPage = 5;
    const totalItems = filteredKeys.length;
    const maxPage = Math.max(1, Math.ceil(totalItems / itemsPerPage));
    const safeCurrentPage = Math.min(currentPage, maxPage);
    const indexOfLastItem = safeCurrentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredKeys.slice(indexOfFirstItem, indexOfLastItem);

    console.log("current item", currentItems);



    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const totalPages = Math.ceil(filteredKeys.length / rowsPerPage);

    const handlePageChange = (event) => {
        setCurrentPage(Number(event.target.value));
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const currentRows = filteredKeys.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

        let startPage = Math.max(currentPage - 5, 1);
        let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

        // Adjust startPage if endPage exceeds totalPages
        if (endPage === totalPages) {
            startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <PaginationButton
                    key={i}
                    className={currentPage === i ? 'active' : ''}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </PaginationButton>
            );
        }

        return pageNumbers;
    };
    const [isExpanded, setIsExpanded] = useState(true);
    const toggleExpandCollapse = () => {
        setIsExpanded(!isExpanded);
    };

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupData, setPopupData] = useState('');

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);


    const [uploadDocs, setUploadDocs] = useState(false);
    const [uploadNDA, setUploadNDA] = useState(false);
    const [uploadTraining, setUploadTraining] = useState(false);
    const [uploadSafety, setUploadSafety] = useState(false);
    const [documentFile, setDocumentFile] = useState('');
    const [ndaFile, setNdaFile] = useState('');
    const handleReset = () => {
        setUploadDocs(false);
        setUploadNDA(false);
        setUploadTraining(false);
        setUploadSafety(false);
        setDocumentFile('');
        setNdaFile('');

        // reset any other form fields here
        setFormData({
            courierName: "",
            courierType: "",
            courierAddress: "",
            trackingID: "",
            contactName: "",
            mobileNo: "",
            email: "",
        });
    };
    const [showOtherCompany, setShowOtherCompany] = useState(false);

    const [formData, setFormData] = useState({
        courierName: "",
        courierType: "",
        courierAddress: "",
        trackingID: "",
        contactName: "",
        mobileNo: "",
        email: "",
    });
    console.log("my Form data", formData);
    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [errors, setErrors] = useState({});

    const handleSubmit = async () => {
        const newErrors = {};

        // Required field validation
        if (!String(formData.courierName).trim()) newErrors.courierName = 'Please fill all the fields.';
        if (!String(formData.courierType).trim()) newErrors.courierType = 'Please fill all the fields.'
        // if (!String(formData.courierAddress).trim()) newErrors.courierAddress = 'Please fill all the fields.';
        // if (!String(formData.trackingID).trim()) {
        //     newErrors.trackingID = 'Please fill all the fields.';
        // } else 
        // if (!/^[a-zA-Z0-9-]+$/.test(formData.trackingID)) {
        //     newErrors.trackingID = 'Tracking ID can only contain letters, numbers, and dashes (-).';
        // } if (!String(formData.contactName).trim()) newErrors.contactName = 'Please fill all the fields.';
        // if (!String(formData.mobileNo).trim()) newErrors.mobileNo = 'Please fill all the fields.';
        // if (!String(formData.email).trim()) {
        //     newErrors.email = 'Please fill all the fields.';
        // } else 
        if (formData.email !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Enter a valid email address.';
          }
          

        // If any errors, block submission
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);

            const firstErrorKey = Object.keys(newErrors)[0];
            const firstErrorMessage = newErrors[firstErrorKey];

            toast.error(firstErrorMessage);
            return;
        }

        try {
            if (isEditing) {
                const response = await UpdateCourierMaster({ ...formData, id: editingId, });
                toast.success(response?.res_message || ' updated successfully!');
            } else {
                const response = await AddCourierMaster(formData);
                toast.success(response?.res_message || 'added successfully!');
            }

            // Reset form & refresh data
            setFormData({
                courierName: "",
                courierType: "",
                courierAddress: "",
                trackingID: "",
                contactName: "",
                mobileNo: "",
                email: "",
            });
            setErrors({});
            setIsEditing(false);
            setEditingId(null);
            setIsModalOpen(false);
            fetchAllCourier(); // Refresh list
        } catch (err) {
            toast.error(isEditing ? 'Failed to update courier.' : 'Failed to add courier.');
            console.error(err);
        }
    };

    const handleEdit = (row) => {
        console.log("row", row)
        setFormData({
            courierName: row.courierName,
            courierType: row.courierType,
            courierAddress: row.courierAddress,
            trackingID: row.trackingID,
            contactName: row.contactName,
            mobileNo: row.mobileNo,
            email: row.email,
        });
        setEditingId(row.id); // or row.courierId based on your backend
        setIsEditing(true);
        setIsModalOpen(true);
        setErrors({});
    };

    return (
        <Container>
            <Header>
                <Heading>Courier Master</Heading>
                <SearchBox>
                    <SearchIcon size={20} />
                    <SearchInput
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </SearchBox>
            </Header>
            <Card>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button className="add-location" onClick={handleAddLocationClick}>
                        Add Entry<FiPlus size={20} />
                    </Button>
                </div>

            </Card>
            <TableContainer>
                <StyledTable>
                    <thead>
                        <tr>
                            <TableHeader colSpan={'10'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Courier Master Details</span>
                                    <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                                        {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                                    </IconWrapper>
                                </div>
                            </TableHeader>
                        </tr>
                    </thead>
                    {isExpanded && (
                        <>
                            <thead>
                                <tr>
                                    {/* <TableHeader onClick={() => handleSort('trackingID')}>
                                        Courier Tracking ID {sortColumn === 'trackingID' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </TableHeader> */}

                                    <TableHeader onClick={() => handleSort('courierName')}>
                                        Courier Company Name {sortColumn === 'courierName' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </TableHeader>

                                    <TableHeader onClick={() => handleSort('courierType')}>
                                        Courier Type {sortColumn === 'courierType' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </TableHeader>

                                    <TableHeader onClick={() => handleSort('mobileNo')}>
                                        Contact Details {sortColumn === 'mobileNo' && (sortDirection === 'asc' ? '↑' : '↓')}
                                    </TableHeader>
                                    <TableHeader>Action</TableHeader>
                                </tr>
                            </thead>

                            <tbody>
                                {currentItems && currentItems.length > 0 ? (
                                    currentItems.map((row, idx) => (
                                        <TableRow key={idx}>
                                            {/* <TableCell>{row.trackingID}</TableCell> */}
                                            <TableCell>{row.courierName}</TableCell>
                                            <TableCell>{row.courierType}</TableCell>
                                            <TableCell>{row.mobileNo}</TableCell>
                                            <TableCell>
                                                <IconWrapper onClick={() => handleEdit(row)}>
                                                    <FiEdit />
                                                </IconWrapper>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>No key logs available.</TableCell>
                                    </TableRow>
                                )}
                            </tbody>
                        </>
                    )}
                </StyledTable>
                {isExpanded && (
                    <>
                        <PaginationContainer>
                            <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                                Previous
                            </PaginationButton>

                            <DropdownSelect value={currentPage} onChange={handlePageChange}>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <option key={i + 1} value={i + 1}>
                                        Page {i + 1}
                                    </option>
                                ))}
                            </DropdownSelect>

                            <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                                Next
                            </PaginationButton>
                        </PaginationContainer>
                    </>
                )}
                {isModalOpen && (
                    <ModalContainer>
                        <ModalHeader>
                            <ModalTitle>{isEditing ? "Update Courier Entry" : "Add Courier Entry"}</ModalTitle>
                            <CloseIcon size={24} onClick={handleCloseModal} />
                        </ModalHeader>

                        <InputGroup>
                            <FlexRow>
                                {/* Left Column */}
                                <InputFieldHalf>
                                    {/* <Label>Courier Tracking ID</Label>
                                    <Input
                                        type="text"
                                        placeholder="Enter Tracking ID"
                                        value={formData.trackingID}
                                        // hasError={!!errors.trackingID}

                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const sanitized = value.replace(/[^a-zA-Z0-9-\s]/g, '');
                                            setFormData({ ...formData, trackingID: sanitized });
                                        }}
                                        required
                                    /> */}
                                    {/* {errors.trackingID && <span className="error">{errors.trackingID}</span>} */}

                                    <Label>Courier Company Name<Asterisk>*</Asterisk></Label>
                                    <Input
                                        type="text"
                                        placeholder="Enter Courier Company Name"
                                        value={formData.courierName}
                                        hasError={!!errors.courierName}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const onlyLetters = value.replace(/[^a-zA-Z\s]/g, ''); // ✅ keep only letters
                                            setFormData({ ...formData, courierName: onlyLetters });
                                        }}
                                        required
                                    />
                                    {/* {errors.courierName && <span className="error">{errors.courierName}</span>} */}


                                    <Label>Courier Type<Asterisk>*</Asterisk></Label>
                                    <DropdownSelect
                                        value={formData.courierType}
                                        hasError={!!errors.courierType}

                                        onChange={(e) => setFormData({ ...formData, courierType: e.target.value })}
                                        required
                                    >
                                        <option value="">Select Type</option>
                                        <option value="Local">Local</option>
                                        <option value="National">National</option>
                                        <option value="International">International</option>
                                        <option value="Express">Express</option>

                                    </DropdownSelect>
                                    {/* {errors.courierType && <span className="error">{errors.courierType}</span>} */}


                                    <Label>Courier Address / Office Location</Label>
                                    <TextArea
                                        type="text"
                                        placeholder="Enter Address"
                                        value={formData.courierAddress}
                                        // hasError={!!errors.courierAddress}
                                        onChange={(e) => setFormData({ ...formData, courierAddress: e.target.value })}
                                        required
                                    />
                                    {/* {errors.courierAddress && <span className="error">{errors.courierAddress}</span>} */}

                                </InputFieldHalf>

                                <InputFieldHalf>
                                    <Label>Contact Person Name</Label>
                                    <Input
                                        type="text"
                                        placeholder="Enter Name"
                                        value={formData.contactName}
                                        // hasError={!!errors.contactName}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const sanitized = value.replace(/[^a-zA-Z\s]/g, '');
                                            setFormData({ ...formData, contactName: sanitized });
                                        }}
                                        required
                                    />
                                    {/* {errors.contactName && <span className="error">{errors.contactName}</span>} */}

                                    <Label>Phone Number</Label>
                                    <Input
                                        type="tel"
                                        placeholder="Enter Phone Number"
                                        value={formData.mobileNo}
                                        // hasError={!!errors.mobileNo}

                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d{0,15}$/.test(value)) {  // allow only up to 15 digits
                                                setFormData({ ...formData, mobileNo: value });
                                            }
                                        }}
                                        pattern="^\d{1,15}$"
                                        maxLength={15}
                                        required
                                    />
                                    {/* {errors.mobileNo && <span className="error">{errors.mobileNo}</span>} */}


                                    <Label>Email Address</Label>
                                    <Input
                                        type="email"
                                        placeholder="Enter Email"
                                        value={formData.email}
                                        // hasError={!!errors.email}
                                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                        required
                                    />
                                    {/* {errors.email && <span className="error">{errors.email}</span>} */}


                                </InputFieldHalf>

                            </FlexRow>
                        </InputGroup>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                            <ResetButton onClick={handleReset}>Reset</ResetButton>
                            <SubmitButton onClick={() => {
                                handleSubmit();
                            }
                            }>Submit</SubmitButton>
                        </div>
                    </ModalContainer>

                )}


            </TableContainer>
            <ToastContainer />

        </Container>
    );
};

export default CourierMaster;
